<script>
export default {
  name: 'FullScreenOverlay',
};
</script>

<template>
  <div class="root">
    <div class="root__wrapper">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.root {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  flex-grow: 1;
  padding: 30px 0;
  background-size: cover;
  background-position: center center;
  display: flex;
  flex-direction: column;
  background-color: #0e0e0e;

  &__wrapper {
    max-width: 1210px;
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &.shadowBg {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(29, 29, 29, 0.9);
      z-index: 1;
    }

    .root__wrapper {
      position: relative;
      z-index: 2;
    }
  }
}

@media (max-width: $mobile) {
  .root {
    padding: 20px 0 30px;
    min-height: auto;
    &__wrapper {
      padding: 0 15px;
    }
  }
}
</style>
